// extracted by mini-css-extract-plugin
export default {"box":"styles_box__n+eRO","helpBtn":"styles_helpBtn__3JHPU","onLargeOnly":"styles_onLargeOnly__lYD9a"};